import React from "react";
import { motion, AnimatePresence } from "framer-motion";

interface CustomRadioButtonProps {
  label?: string;
  name: string;
  value: string;
  checked: boolean;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

const FleetrifyRadioButton: React.FC<CustomRadioButtonProps> = ({
  label,
  name,
  value,
  checked,
  onValueChange,
  disabled,
}) => {
  // Keyboard handler for accessibility (simulate radio behavior)
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (disabled) return;

    if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      onValueChange(value);
    }
  };

  return (
    <div
      role="radio"
      aria-checked={checked}
      tabIndex={disabled ? -1 : 0}
      onClick={() => !disabled && onValueChange(value)}
      onKeyDown={handleKeyDown}
      aria-disabled={disabled}
      className={`flex items-center space-x-3 cursor-pointer select-none ${
        disabled ? "cursor-not-allowed opacity-50" : ""
      }`}
      style={{ outline: "none" }}
    >
      <span
        className={`w-5 h-5 rounded-full border-2 border-[#143887] flex items-center justify-center transition-colors duration-300 ease-in-out
          ${
            checked
              ? "bg-[#143887] border-[#143887]"
              : "bg-white border-[#143887]"
          }`}
      >
        <AnimatePresence>
          {checked && (
            <motion.span
              key="dot"
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.6 }}
              transition={{ duration: 0.2 }}
              className="block w-3 h-3 rounded-full bg-white"
            />
          )}
        </AnimatePresence>
      </span>
      <span className="text-sm font-medium text-[#00032A]">{label}</span>
    </div>
  );
};

export default FleetrifyRadioButton;
